module.exports = __webpack_public_path__ + "static/media/clapping-hands-medium-dark-skin-tone-svgrepo-com.8094444e.svg";